import React from "react";

export const NoteIconSvg = ({ pathNames }) => {
  const specificPathName =
    window.location.pathname === "/home/notetype" ||
    window.location.pathname === "/home/activitylibrary";
  return (
    <div>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        stroke={
          specificPathName
            ? "#ffffff"
            : pathNames.includes("/home/note")
            ? "#ffffff"
            : "#667085"
        }
      >
        <path
          d="M2.167 5.044h-1v2h1zm1.977 2h1v-2h-1zM2.167 9h-1v2h1zm1.977 2h1V9h-1zm-1.977 1.956h-1v2h1zm1.977 2h1v-2h-1zm6.934-6.934v-1h-2v1zm-2 3.956v1h2v-1zM12.056 11h1V9h-1zM8.1 9h-1v2h1zM5.133 2.1h9.89v-2h-9.89zM16 3.078v13.844h2V3.078zM15.022 17.9H5.133v2h9.89zm-10.866-.978v-2.966h-2v2.966zm0-2.966V10h-2v3.956zm0-3.956V6.044h-2V10zm0-3.956V3.078h-2v2.966zM5.133 17.9a.98.98 0 0 1-.977-.978h-2A2.98 2.98 0 0 0 5.133 19.9zM16 16.922c0 .54-.438.978-.978.978v2A2.98 2.98 0 0 0 18 16.922zM15.022 2.1c.54 0 .978.438.978.978h2A2.98 2.98 0 0 0 15.022.1zM5.133.1a2.98 2.98 0 0 0-2.977 2.978h2c0-.54.437-.978.977-.978zM2.167 7.044h.989v-2h-.99zm.989 0h.988v-2h-.988zM2.166 11h.99V9h-.99zm.99 0h.988V9h-.988zm-.99 3.956h.99v-2h-.99zm.99 0h.988v-2h-.988zm5.922-6.934V10h2V8.022zm0 1.978v1.978h2V10zm2.978-1h-1.978v2h1.978zm-1.978 0H8.1v2h1.978z"
          fill="#667085"
        />
      </svg>
    </div>
  );
};
